import { render, staticRenderFns } from "./WPPConnectConfiguration.vue?vue&type=template&id=0c723820&scoped=true&"
import script from "./WPPConnectConfiguration.vue?vue&type=script&lang=js&"
export * from "./WPPConnectConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./WPPConnectConfiguration.vue?vue&type=style&index=0&id=0c723820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c723820",
  null
  
)

export default component.exports